// extracted by mini-css-extract-plugin
export default {"tab-container":"styles_tab-container__jkgtj","tab":"styles_tab__B+bnq","one-item":"styles_one-item__Znp82","active":"styles_active__OGb0p"};